import { Link } from "react-router-dom"
import Button from "../../components/ui/Button"
import Title from "../../components/ui/Title"
import '../../styles/pages/system.scss'

const Minigames = () => {
    return (
        <div className="page-container">
            <div className="line-container">
            <Title
                text="System"
                size="full"
            />
            <header className="system-header">
                <h1 className="system-title">
                    Tons of fun along the way!
                </h1>
                <p>
                    There are plenty of things to do outside of the main story and support requests, such as minigames, cooking, and fishing. Enjoy your adventure alongside Lloyd and his friends!
                </p>
            </header>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Minigames
                    </h1>
                    <p>
                        As you travel throughout Crossbell, you can enjoy fun diversions such as cooking, fishing, and card games at the casino.
                    </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/mini-1.webp`} alt="" />
                </div>
            </div>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Recipe Book
                    </h1>
                    <p>
                        Once you've acquired the proper recipes, you can turn ordinary ingredients into a feast. Each character has their own specialties when it comes to cooking, and between them, you can whip up a variety of special food items. Make supreme dishes that will heal your party or more...peculiar fare you can even use to attack foes.
                    </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/mini-3.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Fishing
                    </h1>
                    <p>
                        After acquiring your first rod and some bait, you'll be able to go fishing any time you happen across a fishing spot. Cast your rod and catch a fish by pressing the button with the right timing! Your catches will be automatically recorded in your Fishing Notebook.
                        <br/>
                        As you catch more fish, you'll be able to move up the ranks in the Fisherman's Guild and get fabulous fishing-related prizes! Will you be able to reel in all the different fish in Crossbell and complete your Fishing Notebook?
                    </p>
                </div>
                <div className="system-info_image">
                    <img src={`${process.env.PUBLIC_URL}/img/ss/mini-2.webp`} alt="AT Battle Images" />
                </div>
            </div>
            <Link to="/system">
                <Button
                    text="Go Back"
                    type="solid"
                />
            </Link>
            </div>
        </div>
    )
}

export default Minigames